module.exports = __webpack_public_path__ + "static/CLASSROOM1-c340582c47c48cbad0019e257b489d69.jpg";